"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _default = (document.body.dataset ? document.body.dataset.appVersion : null) || "unknown";

exports["default"] = _default;